import { useEffect, useState } from "react";
import { Button, Card, Col, Row } from "react-bootstrap";
import { MdDescription } from "react-icons/md";
import { useHistory, useParams } from "react-router-dom";
import {
  DocumentIdProps,
  getDocumentById,
  getRequestForId,
  putDocument,
} from "../../services/requests";

import MyEditor from "../../Components/MyEditor";
import { cpfMask } from "../../utils/cpfFormat";
import dateFormat from "../../utils/dateFormat";
import {
  Box,
  ButtonCancel,
  ButtonReturn,
  ButtonSave,
  CardFooterCustom,
  CardHeader,
  CardIcon,
  ContainerMain,
  Title,
} from "./styles";
import { FilesReceived } from "./components/FilesReceived";
import { RequestDetailsProps } from "../../@types/requests";

type FilesReceivedType = RequestDetailsProps["arquivos_recebidos"];

const DocVisualization = (): JSX.Element => {
  const { id, identificador } = useParams<{
    id: string;
    identificador: string;
  }>();
  const history = useHistory();
  const [doc, setDoc] = useState<DocumentIdProps | null>(null);
  const [filesReceived, setFilesReceived] = useState<FilesReceivedType>();
  const [loading, setLoading] = useState(false);

  const getAllApis = async () => {
    const [documentapi] = await Promise.all([
      getDocumentById(id, identificador),
    ]);
    setDoc(documentapi.data);
  };
  const backToSolicitation = () => {
    if (doc?.solicitacao?.identificador) {
      history.push(`/solicitacoes/detalhes/${doc?.solicitacao?.identificador}`);
    } else {
      history.goBack();
    }
  };

  const updateConformidate = async (conformidade: boolean) => {
    try {
      await putDocument(id, conformidade, identificador);
    } catch (err) {
      console.error(err);
    }
    backToSolicitation();
  };

  const getFilesReceived = async () => {
    setLoading(true);
    try {
      const { data } = await getRequestForId(identificador);

      setFilesReceived(data?.arquivos_recebidos);
      setLoading(false);
    } catch (error) {
      setLoading(false);
      console.log(error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getAllApis();
    getFilesReceived();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const getQRCodeImageURL = (value) => {
    return `https://api.qrserver.com/v1/create-qr-code/?data=${encodeURIComponent(
      value
    )}&size=80x80`;
  };

  const addInfoSign = () => {
    const qrCodeValue = `${(window as any)._env_.REACT_APP_URL_CONSULTAR_DOC}/${
      doc?.solicitacao?.hash
    }/${doc?.solicitacao?.identificador}`;
    const qrCodeImgURL = getQRCodeImageURL(qrCodeValue);

    return `
        <br/>
       <div style="text-align: left; background: #F3F4F7; width: 100%; margin-top: 10px; font-size: 11px; display: flex;  align-items: center;">
          <div>
            Assinado eletronicamente por: ${
              cpfMask(doc?.solicitacao?.user_data?.cpf) || ""
            } • ${doc?.solicitacao?.user_data?.nome || ""} em ${
      doc?.created_at && dateFormat(doc?.created_at, true)
    }
            <br/>
            Hash de verificação:  ${doc?.solicitacao?.hash || ""}
            <br/>
            Identificação:  ${doc?.solicitacao?.identificador || ""}
            <br/>
            “Essa assinatura tem respaldo legal de acordo com a Lei Federal n° 14.063, de 23 de setembro de 2020 e Decreto Estadual nº 48.013, de 13 de abril de 2022.”<br />
            Consulte a autenticidade do documento em: ${
              (window as any)._env_.REACT_APP_URL_CONSULTAR_DOC
            }/
          </div>
           <img src="${qrCodeImgURL}" alt="QRCode" style="image-rendering: crisp-edges; -ms-interpolation-mode: nearest-neighbor; margin-left: 10px" />
        </div>`;
  };

  const filesReceivedElement = () => {
    if (!!filesReceived?.length) {
      const files = filesReceived?.map(
        (file) =>
          `<tr style="height: 22.3906px;">
         <td style="width: 33.3226%; height: 22.3906px;"><span style="font-size: 11pt;"><strong>Nome:</strong> ${file.nome}</span></td>
         <td style="height: 22.3906px; width: 66.6452%;" colspan="2"><span style="font-size: 11pt;"><strong>URL:</strong> 
          <a style="cursor: pointer;" download href="${file.url}" target="_blank">${file.url}</a></td>
       </tr>`
      );

      return `
       <br/>
        <table style="border-collapse: collapse; width: 100%;" border="1">
            <thead>
            <tr style="height: 22.3906px;">
                <th style="width: 33.3226%; height: 22.3906px;" colspan="3"><span style="font-size: 11pt;"><strong>Documentos</strong></span></th>
            </tr>
          </thead>
          <tbody>
            ${files.join("")}
          </tbody>
        </table>`;
    }

    return "";
  };

  return (
    <ContainerMain>
      <Row>
        <Col md={12}>
          <Card>
            <CardHeader>
              <Box>
                <CardIcon>
                  <MdDescription size={20} />
                </CardIcon>
                <Title>{doc?.documento_origem?.assunto}</Title>
              </Box>
              <Button onClick={backToSolicitation}>Voltar</Button>
            </CardHeader>
            <Card.Body>
              {doc && (
                <MyEditor
                  value={`
                      ${doc?.conteudo}
                      ${addInfoSign()}
                      ${filesReceivedElement()}
                    `}
                  print={true}
                />
              )}
            </Card.Body>
            <FilesReceived filesReceived={filesReceived} loading={loading} />
            <CardFooterCustom>
              {doc && !doc.verificado_em ? (
                <>
                  <ButtonCancel
                    onClick={() => {
                      updateConformidate(false);
                    }}
                  >
                    Recusar
                  </ButtonCancel>
                  <ButtonSave
                    onClick={() => {
                      updateConformidate(true);
                    }}
                  >
                    Aceitar
                  </ButtonSave>
                </>
              ) : (
                <ButtonReturn
                  onClick={() => {
                    history.goBack();
                  }}
                >
                  Voltar
                </ButtonReturn>
              )}
            </CardFooterCustom>
          </Card>
        </Col>
      </Row>
    </ContainerMain>
  );
};

export default DocVisualization;
